import {
  BusinessUnitItemSchema,
  VendorItemSchema,
  AccountItemSchema,
  ScanDataAltriaRcnItemSchema,
} from "@/schemas/index";
import { z } from "zod";

export const ScanDataConfigSchema = z.object({
  Account: z.object({
    Id: AccountItemSchema.shape.Id,
    Name: AccountItemSchema.shape.Name,
    LegalEntityId: z.string().optional(),
    Login: z.string().optional(),
    Number: z.string().optional(),
    Password: z.string().optional(),
    Status: z.string().optional(),
    StatusId: z.number().optional(),
  }),
  LocationLevel: z.boolean().optional(),
  SetupVendorIds: z.number().array().optional(),
  AccountNumbers:
    ScanDataAltriaRcnItemSchema.shape.AccountNumber.array().optional(),
  BusinessUnits: z
    .object({
      Id: BusinessUnitItemSchema.shape.Id,
      Name: BusinessUnitItemSchema.shape.Name,
      Status: z.string().optional(),
      StatusId: z.number().optional(),
      AccountNumber: z.string().optional(),
      Address: z.string().optional(),
      Number: z.string().optional(),
      CredStatusId: z.number().optional(),
      Error: z.string().optional(),
      LegalEntityId: z.string().optional(),
      Login: z.string().optional(),
      Password: z.string().optional(),
    })
    .array(),
  VendorId: VendorItemSchema.shape.Id,
  VendorName: VendorItemSchema.shape.Name.optional(),
});

export type ScanDataConfigType = z.infer<typeof ScanDataConfigSchema>;
